import moment from "moment";
import _, { compact } from "lodash";

export const camelize = (params: any): any => {
  if (params === null || params === undefined) return null;
  if (typeof params !== "object") return params;
  if (moment.isMoment(params)) return params.toJSON();
  if (Array.isArray(params)) return params.map((item) => camelize(item));
  return Object.keys(params).reduce((results, key) => {
    const item = params[key];
    return {
      ...results,
      [_.camelCase(key)]: typeof item === "object" ? camelize(item) : item,
    };
  }, {});
};

export const decamelize = (params: any): any => {
  if (params === null || params === undefined) return null;
  if (params instanceof FormData) {
    const formData = new FormData();
    params.forEach((value, key) => {
      formData.append(_.snakeCase(key), value);
    });
    return formData;
  }
  if (typeof params !== "object") return params;
  if (moment.isMoment(params)) return params.toJSON();
  if (Array.isArray(params)) return params.map((item) => decamelize(item));
  return Object.keys(params).reduce((results, key) => {
    const item = params[key];
    return {
      ...results,
      [_.snakeCase(key)]: typeof item === "object" ? decamelize(item) : item,
    };
  }, {});
};

export const toFormData = (params: { [key: string]: string | Blob }) => {
  const formData = new FormData();
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
};

export const toPriceDisplay = (price: number | string, fixed) => {
  const re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return (price?.toString().match(re) || "")[0];
};
